import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Order } from 'types';

type Props = {
  order: Order;
  refetchOrderStatus: () => void;
};

export const SqCountdownTimer: React.FC<Props> = ({
  order,
  refetchOrderStatus,
}) => {
  const initialRemaining = useMemo(
    () =>
      Math.max(
        0,
        Math.round(
          (new Date(order.statusTimeoutAt).getTime() - Date.now()) / 1000,
        ),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const [remaining, setRemaining] = useState(initialRemaining);

  const formatTime = useCallback((seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }, []);

  useEffect(() => {
    if (remaining <= 0) {
      refetchOrderStatus();
      return;
    }
    const id = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          refetchOrderStatus();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [remaining, refetchOrderStatus]);

  return (
    <div className="tw-flex tw-items-center tw-gap-1 tw-bg-blue-50 tw-border tw-border-solid tw-border-blue-200 tw-text-blue-600 tw-text-sm tw-font-medium tw-rounded-full tw-px-3 tw-py-1 tw-shrink-0">
      <svg
        className="tw-w-3.5 tw-h-3.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
      <span className="tw-inline-block tw-w-10 tw-text-center">
        {formatTime(remaining)}
      </span>
    </div>
  );
};
